var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: "25%",
            "class-name": "vertical-center-modal",
            "footer-hide": "",
            "mask-closable": false,
            closable: false,
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("Icon", {
                staticClass: "icon",
                attrs: { type: "ios-alert", color: "#FF6639", size: "74" },
              }),
              _c("p", { staticClass: "p-text" }, [_vm._t("info")], 2),
              _vm.isClose
                ? _c(
                    "div",
                    [
                      _c(
                        "Button",
                        {
                          attrs: { size: "large", type: "error", ghost: "" },
                          on: { click: _vm.cancelClose },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                      _c(
                        "Button",
                        {
                          attrs: { size: "large", type: "error" },
                          on: { click: _vm.okClose },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.ensure")))]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "Button",
                        {
                          attrs: { size: "large", type: "error", ghost: "" },
                          on: { click: _vm.cancelDel },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                      _c(
                        "Button",
                        {
                          attrs: { type: "error", size: "large" },
                          on: { click: _vm.okDel },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.delete")))]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: "25%",
            "class-name": "vertical-center-modal",
            "footer-hide": "",
            "mask-closable": false,
            closable: false,
          },
          model: {
            value: _vm.isPropertyModal,
            callback: function ($$v) {
              _vm.isPropertyModal = $$v
            },
            expression: "isPropertyModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("Icon", {
                staticClass: "icon",
                attrs: {
                  type: "ios-checkmark-circle",
                  size: "74",
                  color: "#FF4330",
                },
              }),
              _vm.isDel
                ? _c("p", { staticClass: "p-text" }, [
                    _vm._v(_vm._s(_vm.$t("face.unbindTip"))),
                  ])
                : _vm.isBind
                ? _c("p", { staticClass: "p-text" }, [
                    _vm._v(_vm._s(_vm.$t("code.setNo"))),
                  ])
                : _vm.isBooking
                ? _c("p", { staticClass: "p-text" }, [
                    _vm._v(_vm._s(_vm.$t("visit.noBooking"))),
                  ])
                : _vm.isVisit
                ? _c("p", { staticClass: "p-text" }, [
                    _vm._v(_vm._s(_vm.$t("visit.noVisit"))),
                  ])
                : _c("p", { staticClass: "p-text" }, [
                    _vm._v(_vm._s(_vm.$t("common.delSuccess"))),
                  ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }